import { useEffect } from "react";
// aos
import AOS from "aos";
import "aos/dist/aos.css";
import Layout from "../Layout/Layout";
import BannerImg from "../../assets/LawLogo2-removebg-preview.png";
import BgImg from "../../assets/coffee-texture.jpg";
import { viewTeams } from "../../states/actions/teamsAction";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../loading/Loading";
import BaseUrl from "../../service/API/base_url";
import HeroImage from "../../assets/photo_2026-03-28_11-24-19.jpg";
import Careers from "./careers";
import Partners from "./Partners";
import AboutNavigation from "./header";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 3000 });
  }, []);

  const bgImage = {
    backgroundImage: `url(${BgImg})`,
    backgroundColor: "#270c03",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "100%",
    width: "100%",
  };

  // dispatch
  const dispatch = useDispatch();
  // hooks
  const teams = useSelector((state) => state.teams);
  // use effect
  useEffect(() => {
    dispatch(viewTeams());
  }, []);

  // console.log("teams : ", teams);
  return (
    <Layout
      title="About Aderaw Addisu | Lawyer and Legal Consultant in Bahir Dar Ethiopia"
      description="Learn about Aderaw Addisu Law Office, a trusted law firm in Bahir Dar providing litigation, arbitration, property, contract and business legal services."
      keywords="About Aderaw Addisu, Lawyer in Bahir Dar, Law Office Ethiopia"
    >
      <section className="">
        <section className="relative w-full h-[65vh] overflow-hidden">
          {/* Background Image */}
          <div
            className="absolute inset-0 w-full h-full bg-center bg-cover"
            style={{ backgroundImage: `url(${HeroImage})` }}
          ></div>

          {/* Optional overlay */}
          <div className="absolute inset-0 bg-black/50"></div>

          {/* Content */}
          <div className="relative z-10 flex items-center justify-center h-full w-full text-center px-6">
            <h2 className="text-4xl md:text-6xl font-bold text-white">
              About Us
            </h2>
          </div>
        </section>
        <div>
          <AboutNavigation />

          <section id="who" className="py-16 px-4 md:px-16 bg-white">
            {/* Section Heading */}
            <h2 className="text-center text-4xl font-bold text-gray-300 mb-12">
              WHO WE ARE
            </h2>

            {/* Content Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
              {/* Left Column - Logo */}
              <div className="flex justify-center md:justify-start">
                <h3 className="text-lg font-bold mb-4">
                  አደራው አዲሱ በፌደራል እና በክልል 1ኛ  ደረጃ የህግ ማማከርና የጥብቅና አገልግሎት
                </h3>
                {/* Optional small line next to logo */}
                <div className="hidden md:block ml-4 h-0.5 w-16 bg-[#755542] self-center"></div>
              </div>

              {/* Right Column - Text */}
              <div className="md:col-span-2">
                <h3 className="text-lg font-bold mb-4">About Us</h3>
                <p className="mb-4 text-gray-700 leading-relaxed">
                  Founded in 2012, Aderaw Addisu Law Office is a professional
                  law office located in Bahir Dar, Ethiopia. The office is
                  dedicated to providing reliable, ethical, and high-quality
                  legal services to individuals, businesses, and organizations.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Our practice areas include corporate law, contract preparation
                  and negotiation, litigation, arbitration, property and real
                  estate matters, employment law, immigration services, and
                  human rights advocacy. We provide legal advice,
                  representation, and consultancy services to a wide range of
                  clients.Aderaw Addisu Law Office operates in full compliance
                  with the laws of the Federal Democratic Republic of Ethiopia
                  and is licensed by the Federal Attorney General to provide
                  legal services throughout the country.
                </p>
              </div>
            </div>
          </section>

          <div style={bgImage}>
            <div className="min-h-[550px] flex justify-center items-center py-12 sm:py-0 ">
              <div className="container">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {/* Image section */}
                  <div data-aos="zoom-in">
                    <img
                      src={BannerImg}
                      alt="biryani img"
                      className="max-w-[230px] w-full mx-auto drop-shadow-[10px_-10px_12px_rgba(0,0,0,1)] spin"
                    />
                  </div>
                  {/* text content section */}
                  <div className="flex flex-col justify-center gap-6 sm:pt-0">
                    <h1
                      data-aos="fade-up"
                      className="text-3xl sm:text-4xl font-bold font-cursive"
                    >
                      Core Values
                    </h1>
                    <p
                      data-aos="fade-up"
                      className="text-sm text-gray-500 tracking-wide leading-5"
                    >
                      Ethiopia is one of Africa's fastest-growing investment
                      destinations, yet its legal and regulatory environment
                      demands experienced local counsel. Our founding partners —
                      all former Federal Supreme Court judges — provide foreign
                      investors with unmatched insight into how Ethiopian law is
                      interpreted and applied at the highest levels.
                    </p>

                    <div className="grid grid-cols-2 gap-6">
                      <div data-aos="slide-up" className=" space-y-2">
                        <h1 className="text-2xl font-semibold font-cursive ">
                          Vision
                        </h1>
                        <p className="text-sm text-gray-500">
                          To become a respected and trusted law office in
                          Ethiopia, known for delivering professional legal
                          services, strong client relationships, and reliable
                          legal solutions.
                        </p>
                      </div>
                      <div
                        data-aos="slide-up"
                        className="border-l-4 border-primary/50 pl-6 space-y-2"
                      >
                        <h1 className="text-2xl font-semibold font-cursive ">
                          Mission
                        </h1>
                        <p className="text-sm text-gray-500">
                          We are committed to delivering client-focused
                          representation, resolving disputes through
                          negotiation, mediation, arbitration, and litigation,
                          and maintaining the highest standards of honesty,
                          professionalism, and integrity while promoting justice
                          and the rule of law.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="team"
            className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20"
          >
            <div className="mx-auto mb-10 lg:max-w-xl sm:text-center">
              <p className="inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-teal-accent-400">
                Know Our Team
              </p>
              <p className="text-base text-gray-700 md:text-lg">
                Ethiopia's only law office founded by five former Federal
                Supreme Court and High Court judges. Bringing 26+ years of
                combined judicial experience to every client engagement.
              </p>
            </div>
            <div className="grid gap-10 mx-auto grid-cols-2 lg:max-w-screen-lg">
              {teams?.teams?.length > 0 ? (
                teams?.teams?.map((info, index) => (
                  <div key={index} className="grid sm:grid-cols-3">
                    <div className="relative w-full h-48 max-h-full rounded shadow sm:h-auto">
                      <img
                        className="absolute object-cover w-full h-full rounded"
                        src={`${BaseUrl}${info?.photo}`}
                        alt="Person"
                      />
                    </div>
                    <div className="flex flex-col justify-center mt-5 sm:mt-0 sm:p-5 sm:col-span-2">
                      <p className="text-lg font-bold">{info?.name}</p>
                      <p className="mb-4 text-xs text-gray-800">
                        {info?.position}{" "}
                      </p>
                      <p className="mb-4 text-sm tracking-wide text-gray-800">
                        {info?.teamMemberBio}
                      </p>
                      <div className="flex items-center space-x-3">
                        <a
                          href={`${info?.twitter}`}
                          className="text-gray-600 transition-colors duration-300 hover:text-deep-purple-accent-400"
                        >
                          <svg
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="h-5"
                          >
                            <path d="M24,4.6c-0.9,0.4-1.8,0.7-2.8,0.8c1-0.6,1.8-1.6,2.2-2.7c-1,0.6-2,1-3.1,1.2c-0.9-1-2.2-1.6-3.6-1.6 c-2.7,0-4.9,2.2-4.9,4.9c0,0.4,0,0.8,0.1,1.1C7.7,8.1,4.1,6.1,1.7,3.1C1.2,3.9,1,4.7,1,5.6c0,1.7,0.9,3.2,2.2,4.1 C2.4,9.7,1.6,9.5,1,9.1c0,0,0,0,0,0.1c0,2.4,1.7,4.4,3.9,4.8c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6,0-0.9-0.1c0.6,2,2.4,3.4,4.6,3.4 c-1.7,1.3-3.8,2.1-6.1,2.1c-0.4,0-0.8,0-1.2-0.1c2.2,1.4,4.8,2.2,7.5,2.2c9.1,0,14-7.5,14-14c0-0.2,0-0.4,0-0.6 C22.5,6.4,23.3,5.5,24,4.6z"></path>
                          </svg>
                        </a>
                        <a
                          href={`${info?.linkedn}`}
                          className="text-gray-600 transition-colors duration-300 hover:text-deep-purple-accent-400"
                        >
                          <svg
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="h-5"
                          >
                            <path d="M20.452 20.452h-3.554v-5.569c0-1.328-.026-3.037-1.85-3.037-1.851 0-2.134 1.445-2.134 2.94v5.666H9.36V9h3.413v1.561h.049c.476-.9 1.637-1.85 3.368-1.85 3.6 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zm1.778 13.019H3.559V9h3.556v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.728v20.543C0 23.226.792 24 1.771 24h20.451C23.2 24 24 23.226 24 22.271V1.728C24 .774 23.2 0 22.225 0z" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <Loading />
              )}
            </div>
          </div>
          <section id="partners">
            <Partners />
          </section>
          <section id="careers">
            <Careers />
          </section>
        </div>
      </section>
    </Layout>
  );
};
export default About;
